import type { ButtonProps } from '~/components/ui/button'
import { useTranslation } from 'react-i18next'
import { Button } from '~/components/ui/button'
import { useAuth } from '~/helpers/store/auth'
import { useOpenBillingPortal } from '~/pages/backoffice/admin/billing/use-open-billing-portal'

type Props = Pick<ButtonProps, 'variant'> & {
  /** Le texte du bouton, selon ce que l'admin y vient chercher. */
  children: React.ReactNode
}

/** Ouvre le portail client Stripe (#353). Grisé en impersonation : l'API refuse aussi. */
function BillingPortalButton({ variant, children }: Props) {
  const { t } = useTranslation()
  const { open, opening } = useOpenBillingPortal()
  const impersonating = useAuth(state => Boolean(state.payload?.impersonatorId))

  return (
    <Button type="button" variant={variant} disabled={opening || impersonating} aria-busy={opening} onClick={() => void open()}>
      {opening ? t('billing.portal.opening') : children}
    </Button>
  )
}

export default BillingPortalButton
